import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { useCookies } from "react-cookie";
import { Turnstile } from "@marsidev/react-turnstile";
import socket from "../components/socket";

const Login = () => {
  const navigate = useNavigate();
  const [, removeCookie] = useCookies([]);
  const [inputValue, setInputValue] = useState({
    email: "",
    password: "",
  });
  const [turnstileToken, setTurnstileToken] = useState("");
  const turnstileRef = useRef(null);
  // console.log('Server URL:', process.env.REACT_APP_SERVER_URL);
  const { email, password } = inputValue;
  const handleOnChange = (e) => {
    const { id, value } = e.target;
    setInputValue({
      ...inputValue,
      [id]: value,
    });
  };

  const handleError = (err) =>
    toast.error(err, {
      position: "bottom-left",
    });

  const handleSuccess = (msg) =>
    toast.success(msg, {
      position: "bottom-left",
    }
    );

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/api/v1/login`,
        {
          ...inputValue,
          turnstileToken,
        },

        { withCredentials: true }
      );
      const { success, message, role } = data;
      if (!success) {
        removeCookie("token");
        handleError(message);
        turnstileRef.current?.reset();
        setTurnstileToken("");
        return;
      }
      if (!role) {
        removeCookie("token");
        handleError(message);
        turnstileRef.current?.reset();
        setTurnstileToken("");
        return;
      }
      handleSuccess(message);

      // The shared socket may have connected before login (no auth cookie
      // yet); force a fresh handshake so the server picks up the new session.
      socket.disconnect();
      socket.connect();

      setTimeout(() => {
        navigate(`/${role}`);
      }, 1000);
    } catch (error) {
      console.error(error);
    }
    setInputValue({
      ...inputValue,
      email: "",
      password: "",
    });
  };

  return (
    <>
    <div className="form_container">
      <h2>Login Account</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            value={email}
            placeholder="Enter your email"
            onChange={handleOnChange}
            autoComplete="email"
          />
        </div>
        <div>
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            value={password}
            placeholder="Enter your password"
            onChange={handleOnChange}
          />
        </div>
        <div className="turnstile_container">
          <Turnstile
            ref={turnstileRef}
            siteKey={process.env.REACT_APP_TURNSTILE_SITE_KEY}
            onSuccess={setTurnstileToken}
            onExpire={() => setTurnstileToken("")}
          />
        </div>
        <button type="submit" disabled={!turnstileToken}>Submit</button>

      </form>
    </div>
    
      <ToastContainer />
    </>
  );
};

export default Login;
